import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { configService } from "../services/configService";
import { PartnerType } from "../utils/partners.enum";
import { TriStateEnum } from "../entities/TriState";
import { useAuth } from "./useAuth";

export const useProductVisibility = () => {
  const { isSuperAdmin, isAdmin } = useAuth();

  const { data: catalog } = useQuery({
    queryKey: ["productsCatalog"],
    queryFn: configService.getProductsCatalog,
  });

  const { data: productsConfig } = useQuery({
    queryKey: ["productsConfig"],
    queryFn: configService.getProductsConfig,
  });

  const isProductVisible = useCallback(
    (partner?: PartnerType | string | null): boolean => {
      if (!partner) return false;

      const product = productsConfig?.products?.[partner as PartnerType];

      if (product?.externalData?.active === false) return false;

      switch (product?.state) {
        case TriStateEnum.OFF:
          return isSuperAdmin;
        case TriStateEnum.ON:
          return isAdmin;
        case TriStateEnum.FULL:
          return true;
        default:
          return true;
      }
    },
    [productsConfig, isSuperAdmin, isAdmin],
  );

  return { catalog, productsConfig, isProductVisible };
};
